import { useRef } from "react";
import { motion, useMotionValue, useSpring, useReducedMotion } from "framer-motion";

const VARIANTS = {
    primary:
        "bg-[#0066FF] text-white shadow-[0_0_36px_rgba(0,102,255,0.35)] hover:bg-[#1a75ff] hover:shadow-[0_0_52px_rgba(0,102,255,0.5)]",
    ghost: "glass text-[#0A0F1D] hover:border-[#0066FF]/60 hover:text-[#0066FF]",
};

export const MagneticButton = ({
    children,
    onClick,
    href,
    variant = "primary",
    className = "",
    testid,
    type,
    disabled = false,
    external = false,
}) => {
    const ref = useRef(null);
    const reduce = useReducedMotion();
    const mx = useMotionValue(0);
    const my = useMotionValue(0);
    const x = useSpring(mx, { stiffness: 180, damping: 16, mass: 0.4 });
    const y = useSpring(my, { stiffness: 180, damping: 16, mass: 0.4 });

    const onMove = (e) => {
        if (reduce || !ref.current) return;
        const r = ref.current.getBoundingClientRect();
        mx.set((e.clientX - (r.left + r.width / 2)) * 0.28);
        my.set((e.clientY - (r.top + r.height / 2)) * 0.28);
    };
    const onLeave = () => {
        mx.set(0);
        my.set(0);
    };

    const classes = `relative inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-3.5 font-display text-xs sm:text-sm font-bold uppercase tracking-[0.18em] transition-[background-color,border-color,box-shadow,color] duration-300 select-none ${VARIANTS[variant]} ${className}`;

    const content = (
        <motion.span style={{ x, y }} className="relative z-10 inline-flex items-center gap-2.5">
            {children}
        </motion.span>
    );

    if (href) {
        return (
            <motion.a
                ref={ref}
                data-testid={testid}
                href={href}
                onClick={onClick}
                onMouseMove={onMove}
                onMouseLeave={onLeave}
                whileTap={{ scale: 0.96 }}
                className={classes}
                {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
                {content}
            </motion.a>
        );
    }
    return (
        <motion.button
            ref={ref}
            data-testid={testid}
            type={type || "button"}
            disabled={disabled}
            onClick={onClick}
            onMouseMove={onMove}
            onMouseLeave={onLeave}
            whileTap={{ scale: 0.96 }}
            className={`${classes} disabled:opacity-60 disabled:cursor-not-allowed`}
        >
            {content}
        </motion.button>
    );
};
